<template>
    <div class="deceit_serves">
        <div class="top"></div>
        <div class="center"></div>
        <div class="bottom"></div>
    </div>
</template>

<script>
export default {
    data(){
        return {}
    },
    created(){
         document.getElementsByTagName("title")[0].innerText = "谁是卧底游戏规则";
    },
}
</script>

<style scoped>
.deceit_serves{
    position: relative;
    width: 100vw;   
}
.deceit_serves .top{
    background: url('../../assets/images/deceitimages/v1/1.png')no-repeat;
    background-size: cover;
    height: 41.7rem;
    width:100vw;
  
}
.deceit_serves .center{
    background: url('../../assets/images/deceitimages/v1/2.png')no-repeat;
    background-size: cover;
    height: 43.05rem;
    width:100vw;
  
}
.deceit_serves .bottom{
    background: url('../../assets/images/deceitimages/v1/3.png')no-repeat;
    background-size: cover;
    height: 34.05rem;
    width:100vw;

  
     
}

</style>


// WEBPACK FOOTER //
// src/components/deceit/game_serves.vue